import { Box, Stack, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router";

import { checking_null_undefined } from "utils";

function DwellingChargePointListTable(props: any) {
    const navigate = useNavigate();

    const data = checking_null_undefined(props.chargePoints); // no mapping, no new ID

    const columns: GridColDef[] = [
        {
            field: "label",
            headerName: "Charge Point",
            sortable: false,
            width: 200,
            align: "left",
            headerAlign: "left",
            renderCell: (cell) => <span>{cell.row.label}</span>,
        },
        {
            field: "evseId",
            headerName: "EVSE ID",
            sortable: false,
            width: 200,
            align: "left",
            headerAlign: "left",
            renderCell: (cell) => <span>{cell.row.evseId}</span>,
        },
        {
            field: "cpmsProvider",
            headerName: "CPMS Provider",
            sortable: false,
            width: 200,
            align: "left",
            headerAlign: "left",
            renderCell: (cell) => <span>{cell.row.cpmsProvider}</span>,
        },
        {
            field: "connectors",
            headerName: "Connectors",
            sortable: false,
            width: 250,
            renderCell: (cell) => {
                const connectors = cell.row.connectors ?? [];
                const formatted = connectors
                    .map((c: { type: string; count: number }) => `${c.count}×${c.type}`)
                    .join(", ");
                return <span>{formatted}</span>;
            },
        },
        {
            field: "maxRateKW",
            headerName: "Max Rate (kW)",
            sortable: false,
            width: 150,
            align: "right",
            headerAlign: "right",
            renderCell: (cell) => <span>{cell.row.maxRateKW}</span>,
        },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 100,
            renderCell: (params) => (
                <IconButton
                    onClick={() => props.onDeleteChargePoint?.(params.row.id)}
                    title="Delete Charge Point"
                    size="small"
                >
                    <DeleteIcon color="error" fontSize="small" />
                </IconButton>
            )
        }
    ];

    const CustomNoRowsOverlay = () => (
        <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
            <Typography color="text.secondary">
                No Connectors have been configured.
            </Typography>
        </Stack>
    );

    const CustomNoResultsOverlay = () => (
        <Stack height="100%" alignItems="center" justifyContent="center" p={2}>
            <Typography color="text.secondary">
                Selected filter returned no results
            </Typography>
        </Stack>
    );

    return (
        <Box sx={{ width: '100%', p: 3 }}>
            <DataGrid
                rows={data}
                columns={columns}
                autoHeight
                getRowId={(row) => row.id}
                initialState={{
                    pagination: {
                        paginationModel: { pageSize: 15, page: 0 },
                    },
                }}
                pageSizeOptions={[15]}
                disableColumnMenu
                disableRowSelectionOnClick
                slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                    noResultsOverlay: CustomNoResultsOverlay,
                }}
                sx={{
                    '& .MuiDataGrid-cell': {
                        fontFamily: 'inherit'
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        fontFamily: 'inherit'
                    }
                }}
            />
        </Box>
    );
}

export default DwellingChargePointListTable;
